import script from "./ResourceHub.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceHub.vue?vue&type=script&setup=true&lang=js"

import "./ResourceHub.vue?vue&type=style&index=0&id=3f884f05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f884f05"]])

export default __exports__